import "./HeroEl.css";

// --------------------------------------------------------------------------------------

export default function HeroEl() {
	return (
		<div className="sponsor-hero-el reveal">
			<h1>Let’s build out the brain emulation tech tree</h1>
			<p>
				Support our team and trusted collaborators in developing the next
				branches
			</p>
		</div>
	);
}
